import Core from 'cloudinary-core'

export default new Core.Cloudinary({ cloud_name: 'graphql' })



// WEBPACK FOOTER //
// ./src/lib/images.js